import { CmsValue } from 'core/type/BootstrapConfig.types';
import { createSelector } from '@reduxjs/toolkit';
import { selectCmsFromBootstrap, selectCurrencyCodeFromBootstrap } from 'store/slice/bootstrap';

export interface StateProps {
    cms: CmsValue;
    currency: string;
}

export type Props = StateProps;

export const mapStateToProps = createSelector(selectCmsFromBootstrap, selectCurrencyCodeFromBootstrap, (cms, currency) => ({
    cms,
    currency,
}));
